<template>
	<div class="solution">
		<h2 class="di">Digital Innovationだからできること</h2>
		<p>ITコンサルティングサービス</p>
		<p>貴社の抱えるお悩みや問題点の解決策だけでなく、<br>貴社が見据える未来のビジョンを共有し、ITという視点からビジョン実現に貢献いたします。</p>
		<!--コンテンツ-->
	</div>
</template>

<script>
export default {
	name: "SolutionPage",
	props: {
		BtnNomal: {
			type: String,
			default: "送信",
		},
	},
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rakkas&family=Titan+One&display=swap');
@import "../css/mainslo.css";

.solution {
	position: absolute;
	top: 25%;
	color: #000;
	font-size: large;
	left: 50%;
	transform: translateX(-50%);
	width: 75%;
}

.di {
	position: relative;
	padding: .5em .7em .4em;
	border-bottom: 5px solid #F1C40F;
	color: #ffffff;
	font-family: "Anton", sans-serif;
	font-size: 1.5em;
}

.di::before,
.di::after {
	position: absolute;
	left: 30px;
	bottom: -15px;
	width: 30px;
	height: 15px;
	clip-path: polygon(0 0, 100% 0, 50% 100%);
	content: '';
}

.di::before {
	background-color: #F1C40F;
}

.di::after {
	bottom: -7px;
	background-color: rgba(106, 105, 105, 0.5);
}

p {
	font-weight: 600;
	font-size: 1.5em;
	color: #ffffff;
}

@media screen and (max-width: 480px) {
	.di {
		font-size: 0.9em;
		font-weight: 600;
	}

	.solution {
		width: 90%;
	}

	p {
		font-size: 1em;
	}
}
</style>